import MigratortronBaseService from './MigratortronBaseService';
import { GetResponse, MigrateRequest } from '~/models/Operations';
import mapErrorToObject from '~/transformations/mapAppErrorToObject';

class WorkflowsMigrationService extends MigratortronBaseService {
  constructor(payload: MigrateRequest, preview: boolean) {
    super(payload, preview);
  }

  get raw() {
    return this.sourceRepo.workflows.workflows;
  }

  /**
   * Gets a list of workflow definitions from the Managemet API
   * @returns list of WorkflowDefinition
   */
  GetWorkflows = async () => {
    await this.sourceRepo.workflows.GetWorkflows();

    for (const [projectId, targetRepo] of Object.entries(this.targetRepos)) {
      await targetRepo.workflows.GetWorkflows();
    }

    return this.raw;
  };

  MapGetWorkflowsResponse = () => {
    const { sourceRepo, targetRepos } = this;
    const response: { [alias: string]: GetResponse } = {};
    response[sourceRepo.alias] = {
      [sourceRepo.projectId]: {
        workflows: sourceRepo.workflows.workflows,
        error: mapErrorToObject(sourceRepo.workflows.error),
      },
    };
    for (const [projectId, targetRepo] of Object.entries(targetRepos)) {
      response[targetRepo?.alias || ''] = {
        [projectId]: {
          workflows: targetRepo?.workflows.workflows,
          error: mapErrorToObject(targetRepo?.workflows.error),
        },
      };
    }
    return response;
  };
}

export default WorkflowsMigrationService;
